import React from 'react';
export const useFileUpload = _ref => {
  let {
    files
  } = _ref;
  const fileInputRef = React.useRef(null);
  const fileUploadButtonRef = React.useRef(null);
  const textBelowButtonRef = React.useRef(null);
  const fileHasError = Boolean(files == null ? void 0 : files.find(file => file.state === 'error'));
  const isOneFile = files && files.length === 1;
  const fileErrorMessage = fileHasError && isOneFile ? files[0].errorMessage : undefined;
  return {
    fileInputRef,
    fileUploadButtonRef,
    textBelowButtonRef,
    fileErrorMessage
  };
};
//# sourceMappingURL=useFileUpload.js.map